import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class HeaderService {
    private updateAvatar: Subject<void>;
    constructor() {
        this.updateAvatar = new Subject<void>();
    }
    updateAvatarObservable(): Observable<void> {
        return this.updateAvatar.asObservable();
    }
    updateAvatarSubject(): Subject<void> {
        return this.updateAvatar;
    }
}



// WEBPACK FOOTER //
// ./src/app/services/header.service.ts